"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAYOUT_TYPES = exports.LAYOUT_CLASSES = exports.DEVICE_CLASSES = exports.CARD_BACKGROUND = void 0;

var _theme = require("HubStyleTokens/theme");

var CARD_BACKGROUND = _theme.BASE_BACKGROUND_COLOR_MEDIUM;
exports.CARD_BACKGROUND = CARD_BACKGROUND;
var DEVICE_CLASSES = {
  mobile: 'private-template--mobile',
  tablet: 'private-template--tablet',
  desktop: 'private-template--desktop'
};
exports.DEVICE_CLASSES = DEVICE_CLASSES;
var LAYOUT_CLASSES = {
  'full-width': 'private-template--full-width',
  'max-width': 'private-template--centered'
};
exports.LAYOUT_CLASSES = LAYOUT_CLASSES;
var LAYOUT_TYPES = ['flex', 'grid'];
exports.LAYOUT_TYPES = LAYOUT_TYPES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/page/PageConstants.js
// module id = 688
// module chunks = 209 210 211 212